<div class="switch" [class.active]="value">
    <label>
        <input [(ngModel)]="value" class="switch__input" type="checkbox" [disabled]="disabled"/>
        <span class="switch__control">
            <small></small>
        </span>

        <span class="switch__title">{{ title }}</span>
    </label>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/fields/switch/switch.component.html